import React, { Component } from 'react';

import LoadingDialog from './LoadingDialog';
import ErrorDialog from './ErrorDialog';

import icon_download from '../resources/downloads_a.png';

var request = require('../../utilities/NetworkRequest');

export default class DownloadRetailDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            is_loading: false,
            body_error: {
                is_show: false,
                message: ''
            },
            wholesaler_id: ''
        }
    }

    downloadRetail() {
        this.setState({ is_loading: true }, () => {
            let body = { wholesaler_id: this.props.body.wholesaler_id, user_id: this.props.body.user_id };
            request.onRequestDataGet(1, `/download/retail`, body, res_data => {
                this.setState({ is_loading: false }, () => {
                    // Handle response as plain CSV string
                    if (typeof res_data === 'string') {
                        const csvData = res_data;
                        const blob = new Blob([csvData], { type: 'text/csv' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        // Since res_data is a string, we cannot get filename from headers
                        let filename = 'data-retail.csv';
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    } else {
                        this.setState({
                            body_error: {
                                is_show: true,
                                message: 'Format data tidak sesuai.'
                            }
                        });
                    }
                });
            });
        });
    }

    showErrorDialog(body) {
        if (body.is_show) {
            return <ErrorDialog body_error={body} onCloseDialog={() => this.setState({ body_error: { is_show: false, message: '' } })} />
        } else {
            return null;
        }
    }

    render() {
        return (
            <div onClick={(e) => this.props.onCloseDialog()} className='process_dialog_root layer_a'>
                <div onClick={(e) => e.stopPropagation()} className='process_dialog_container_b'>
                    <LoadingDialog showDialog={this.state.is_loading} />
                    {this.showErrorDialog(this.state.body_error)}
                    <div className='default_text_medium_gray bold_text'><span>Download Data Retail</span></div>
                    <div className='upload_root'>
                        <div className='upload_content normal_padding_top'>
                            <div className='upload_input_wrapper'>
                                <div className='normal_padding_bottom default_text_normal_gray_b bold_text'><u>Download</u></div>
                                <div className='normal_padding_bottom default_text_normal_gray'>Tekan tombol disebelah ini untuk mendownload data retail</div>
                            </div>
                            <div onClick={() => this.downloadRetail()} className='default_text_normal_white_b orange_background upload_button'>
                                <img className='mini_image_c' src={icon_download} alt='' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
